<template>
  <statistik-base v-if="$isObject(values)" :value="values" :stats="statistik" />
</template>

<script>
import StatistikBase from '@/components/shared/StatistikBase';
import { mapActions } from 'vuex';
export default {
  name: 'Statistik',
  components: { StatistikBase },
  data() {
    return {
      values: {},
      statistik: [
        {
          icon: 'mdi-account-check',
          color: 'green',
          label: 'Peserta Diklat',
          key: 'peserta',
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          icon: 'mdi-account-multiple',
          color: 'orange',
          label: 'Total Pengawas',
          key: 'kandidat',
          grid: { cols: 12, md: 6, sm: 12 },
        },
      ],
    };
  },
  methods: {
    ...mapActions('ikmPengawas', ['stats']),

    async fetch() {
      this.values = await this.stats();
    },
  },
};
</script>

<style scoped></style>
